import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appNumberValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => NumberValidatorDirective), multi: true }],
})
export class NumberValidatorDirective implements Validator {
  constructor() {}

  validate(c: UntypedFormControl): ValidationErrors | null {
    if (!!isNaN(Number(c.value)))
      return {
        invalidNumber: !!isNaN(Number(c.value)),
      };
    else return null;
  }
}
